import { loadStripe, Stripe } from '@stripe/stripe-js';

/**
 * Loads Stripe.js and returns a Promise that resolves to a Stripe instance.
 *
 * In production, requires STRIPE_PUBLIC_KEY to be configured (throws error if missing).
 * In development/test, returns null if key is missing (allows app to work without Stripe
 * for testing scenarios like PayPal-only flows).
 *
 * @returns Promise that resolves to Stripe instance, or null if key is missing (dev only)
 * @throws Error in production if STRIPE_PUBLIC_KEY is not configured
 */
export const stripePromise: Promise<Stripe | null> | null = (() => {
  const stripeKey = process.env.STRIPE_PUBLIC_KEY;

  if (!stripeKey) {
    if (process.env.NODE_ENV === 'production') {
      throw new Error(
        'STRIPE_PUBLIC_KEY is required in production but was not configured',
      );
    }
    // In development/test, allow graceful fallback
    if (process.env.NODE_ENV === 'development') {
      console.warn(
        '⚠️ STRIPE_PUBLIC_KEY is not configured. Stripe payments will not be available.',
      );
    }
    return null;
  }

  return loadStripe(stripeKey);
})();
